import React from "react";
import DesktopHeader from "../components/defaultHeader/DesktopHeader";
import Heading from "../components/typography/Heading";
import { Box, Flex } from "@chakra-ui/react";
import ProfileCategoriesCard from "../features/profile/ProfileCategoriesCard";

const ContactInfoPage = () => {
  return (
    <>
      <DesktopHeader headerContent={<Heading>My Profile</Heading>} />
      <Flex px={"48px"}>
        <ProfileCategoriesCard active={"Contact information"} />
      </Flex>
    </>
  );
};

export default ContactInfoPage;
